module.exports = __webpack_public_path__ + "static/media/BackThumbailCasino.c6088bbf.jpg";